export const isCorporateCustomersSection = (url: string): boolean => {
    const wordsForCorporateCustomers = ['unternehmenskunden', 'clients-entreprises', 'clients-entreprises'];
    return wordsForCorporateCustomers.some((word: string) => url.indexOf(word) !== -1);
};

export const addTargetPageName = (url: string, isCorporateCustomersArea: boolean): string => {
    return `${url}?targetPageName=Bauversicherung-${isCorporateCustomersArea ? 'UN' : 'P'}`;
};
